import { render, staticRenderFns } from "./TCLayerChart.vue?vue&type=template&id=b2e11796&"
import script from "./TCLayerChart.vue?vue&type=script&lang=js&"
export * from "./TCLayerChart.vue?vue&type=script&lang=js&"
import style0 from "./TCLayerChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports